<template>
  <el-dialog
    class="wbench-user-select-mobile"
    :visible.sync="visible"
    fullscreen
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
  >
    <div class="select-main">
      <div class="title">
        <el-tabs v-model="group" type="card">
          <el-tab-pane label="组织结构" name="depart"></el-tab-pane>
          <el-tab-pane label="最近" name="recent"></el-tab-pane>
          <el-tab-pane label="用户组" name="group"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="box">
        <div class="lt">
          <component
            :multi-enable="multiEnable"
            v-if="visible"
            ref="userList"
            :is="group"
            :orgId="orgId"
            :checked="checkedList"
            @checkUser="checkUser"
          ></component>
        </div>
        <div class="md"></div>
        <div class="rt">
          <div class="box-item">
            <el-form size="mini">
              <el-form-item>
                <el-input
                  prefix-icon="el-icon-search"
                  placeholder="请输入搜索内容"
                  v-model="searchText"
                  class="search"
                  @input="searchEvt"
                ></el-input>
                <span @click="clearChecked" class="user-select-delete-all">全部删除</span>
              </el-form-item>
            </el-form>
          </div>
          <div class="user-list">
            <el-checkbox-group v-model="rtCheckList" @change="cancelCheckUser">
              <div v-for="(item, index) in showList" :key="index" class="user-item-full right">
                <el-checkbox
                  :label="item"
                  :title="item.realName + '---' + item.corpName + item.departName"
                >
                  <span class="user">{{ item.realName }}</span>
                  <span class="corp">{{ item.corpName }}</span>
                  <div class="clear"></div>
                  <div class="depart">{{ item.departName }}</div>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="wbench-button" size="mini" @click="visible = false">取消</el-button>
      <el-button class="wbench-button" size="mini" type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getUserListByIds, addRecentUserList, trim } from "./api";
import DepartUserList from "./UserList/DepartUserList";
import RecentUserList from "./UserList/RecentUserList";
import { getCookie } from "@szgc/plt-core-v2";
import request from "../../api/request";
import GroupUserList from "../../../pt/components/UserSelect/UserList/GroupUserList";

export default {
  name: "UserSelectMobile",
  components: {
    depart: DepartUserList,
    recent: RecentUserList,
    group: GroupUserList
  },
  props: {
    orgId: {
      type: [String, Number],
      default() {
        return "";
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    multiEnable: {
      type: Boolean,
      default: false
    },
    users: {
      type: [Array, String],
      default: () => []
    }
  },
  watch: {
    show: {
      async handler(newValue) {
        this.rtCheckList = [];
        this.checkedList = [];
        this.showList = [];
        if (newValue === true) {
          this.visible = newValue;
        }
        this.renderCheckedList();
      },
      immediate: true
    },
    visible: {
      handler(newValue) {
        if (newValue === false) {
          this.$emit("update:show", newValue);
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      visible: this.show,
      group: "depart", //recent depart
      userList: [],
      rtCheckList: [],
      checkedList: [],
      prefix: "",
      searchText: "",
      showList: []
    };
  },
  methods: {
    /*最近人员搜索*/
    searchEvt() {
      const searchText = trim(this.searchText);
      this.showList = this.checkedList.filter((item) => {
        if (searchText === "") {
          return item;
        } else {
          if (item.realName && item.realName.indexOf(searchText) > -1) {
            return item;
          } else if (item.corpName && item.corpName.indexOf(searchText) > -1) {
            return item;
          } else if (item.departName && item.departName.indexOf(searchText) > -1) {
            return item;
          } else if (item.mobile && item.mobile.indexOf(searchText) > -1) {
            return item;
          }
        }
      });
    },
    /*选择/取消人员*/
    checkUser(data) {
      const userList = this.$refs.userList.getUserData();
      if (this.multiEnable) {
        //多选
        userList.map((d) => {
          const index = this.checkedList.findIndex((x) => d.userId === x.userId);
          if (index < 0) {
            this.checkedList.push(d);
          }
        });
      } else {
        this.checkedList = [userList[0]];
      }
      let notRows = []; //寻找当前页，但是未被选中的行
      data.data.map((item) => {
        let flag = false;
        userList.map((child) => {
          if (child.userId === item.userId) {
            flag = true;
          }
        });
        if (!flag) {
          notRows.push(item);
        }
      });
      this.checkedList = this.removePoint(this.checkedList, notRows); //删除当前页未被选中行
      this.searchText = "";
      this.searchEvt();
    },
    /*删除数组元素*/
    removePoint(arr1, arr2) {
      for (let i = 0; i < arr2.length; i++) {
        for (let j = 0; j < arr1.length; j++) {
          if (arr2[i].userId === arr1[j].userId) {
            arr1.splice(j, 1);
          }
        }
      }
      return arr1;
    },
    /*右边取消选中*/
    cancelCheckUser() {
      if (this.rtCheckList.length === 0) return;
      const result = [];
      this.checkedList.map((d) => {
        const index = this.rtCheckList.findIndex((x) => x.userId === d.userId);
        if (index < 0) {
          result.push(d);
        }
      });
      this.checkedList = result;
      this.rtCheckList = [];
      this.searchText = "";
      this.searchEvt();
    },
    /*清空已选*/
    clearChecked() {
      this.checkedList = [];
      this.rtCheckList = [];
      this.searchText = "";
      this.searchEvt();
    },
    /**
     * 存储最近选择的用户
     */
    async addRecentUserList(userList) {
      this.prefix = getCookie("plt-api-route") || "";
      try {
        await request({
          url: this.prefix + addRecentUserList(),
          method: "put",
          data: {
            data: userList.map((d) => d.userId)
          }
        });
      } catch (e) {
        this.$message.error(e);
      }
    },
    /*确定*/
    submit() {
      let valueArr = [],
        textArr = [],
        sourceArr = [],
        result = [];
      this.checkedList.map((item) => {
        valueArr.push(item.userId);
        textArr.push(item.realName);
        let source = JSON.parse(JSON.stringify(item));
        sourceArr.push(source);
        result.push({
          realName: item.realName,
          userId: item.userId
        });
      });
      this.$emit("user-checked", {
        valueText: sourceArr.length > 0 ? valueArr.join(",") : "",
        text: textArr.join(","),
        source: sourceArr
      });
      this.visible = false;
      if (result.length > 0) {
        this.addRecentUserList(result);
      }
    },
    /*获取并渲染已选用户*/
    async renderCheckedList() {
      if (!this.users) return;
      if (this.users.length === 0) return;
      this.prefix = getCookie("plt-api-route") || "";
      const { success, message, data } = await request({
        url: this.prefix + getUserListByIds(),
        method: "post",
        data: {
          data: this.users
        }
      });
      if (!success) return this.$message.error("获取已选择用户信息失败：" + message);
      if (data && data.length > 0) {
        this.checkedList = data;
        this.searchEvt();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.wbench-user-select-mobile {
  ::v-deep .el-dialog__header {
    display: none;
  }

  ::v-deep .el-dialog__body {
    width: 100%;
    height: calc(100% - 45px);
    padding: 0;
    font-size: 12px;

    .select-main {
      padding: 10px 10px 0;
      height: calc(100% - 10px);

      .title {
        .el-tabs {
          .el-tabs__header {
            margin-bottom: 0;

            .el-tabs__item {
              height: 30px;
              line-height: 30px;
            }
          }
        }
      }
    }

    .box {
      margin-top: 10px;
      width: 100%;
      height: calc(100% - 45px);

      &:after {
        display: block;
        width: 0;
        height: 0;
        content: "";
        overflow: hidden;
        clear: both;
      }

      > div {
        float: left;
        height: 100%;
        border: 1px solid #d8d8d8;
        box-sizing: border-box;

        &.md {
          width: 50px;
          border: none;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        &.lt {
          width: calc((100% - 50px) / 2);

          .corp-box {
            cursor: pointer;
          }
        }

        &.rt {
          width: calc((100% - 50px) / 2);

          > .box-item {
            overflow: hidden;
            background-color: #f6f9f9;
            padding: 0 10px;
            height: 45px;
            box-sizing: border-box;
            border-bottom: 1px solid #d8d8d8;

            .el-form {
              position: relative;
              top: 3px;

              .search {
                width: calc(100% - 100px);
              }

              .clear-all {
                position: absolute;
                top: 7px;
                right: 5px;
                z-index: 5;
              }
            }
          }

          .user-list {
            height: calc(100% - 56px);
            overflow-x: hidden;
            overflow-y: auto;
            box-sizing: border-box;
          }
        }
      }

      .box-item {
        background-color: #f6f9f9;
        padding: 0 10px;
        height: 45px;
        border-bottom: 1px solid #d8d8d8;

        .el-input {
          margin-top: 4px;
        }
      }
    }

    .user-item-full {
      padding: 5px 10px 2px;
      overflow: hidden;
      border-bottom: 1px solid #d8d8d8;

      &.right {
        padding-right: 0;

        .el-checkbox {
          width: 100%;

          .el-checkbox__input {
            display: none;
          }
        }
      }

      .el-checkbox {
        width: 100%;

        .el-checkbox__input {
          position: relative;
          top: 3px;
          vertical-align: top;
        }

        .el-checkbox__label {
          display: inline-block;
          width: 90%;
          font-size: 13px;

          &:after {
            display: block;
            width: 0;
            height: 0;
            content: "";
            overflow: hidden;
            clear: both;
          }

          .clear {
            &:after {
              display: block;
              width: 0;
              height: 0;
              content: "";
              overflow: hidden;
              clear: both;
            }
          }

          .user {
            display: inline-block;
            float: left;
          }

          .corp {
            display: inline-block;
            float: right;
            width: calc(100% - 100px);
            text-align: right;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .depart {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }

  ::v-deep .el-dialog__footer {
    padding: 5px 10px 0;
  }

  button[type="button"] {
    padding: 6px 18px;
  }
}
</style>
